import {
  gql,
  MutationHookOptions,
  OperationVariables,
  useMutation,
} from '@apollo/client';

import { UserSuccessOutput } from './types';

export interface IEnableDisableUserPoolAppClientIdp {
  enableDisableUserPoolAppClientIdp: UserSuccessOutput;
}

export const ENABLE_DISABLE_USER_POOL_APP_CLIENT_IDP = gql`
  mutation enableDisableUserPoolAppClientIdp($enable: Boolean!) {
    enableDisableUserPoolAppClientIdp(enable: $enable) {
      body {
        data
        message
        success
      }
      status_code
    }
  }
`;

export const useEnableDisableUserPoolAppClientIdp = (
  options: MutationHookOptions<
    IEnableDisableUserPoolAppClientIdp,
    OperationVariables
  >,
) =>
  useMutation<IEnableDisableUserPoolAppClientIdp, OperationVariables>(
    ENABLE_DISABLE_USER_POOL_APP_CLIENT_IDP,
    options,
  );
